import { FC } from 'react'
import { TBlogPostResult } from 'common/cms-types'
import Link from 'next/link'
import { linkResolver } from '../../linkResolver'
import PrismicImage from 'components/PrismicImage'
import useWindowSize from 'components/util/useWindowSize'
import classNames from 'classnames'

type BlogPostMoreResultType = {
  post: TBlogPostResult
  onLinkClick?: () => void
}

const BlogPostMoreResult: FC<BlogPostMoreResultType> = ({
  onLinkClick,
  post,
}) => {
  const { data } = post
  const size = useWindowSize()
  return (
    <Link className='a-unstyled' href={linkResolver(post as any)}>
      <div
        onClick={onLinkClick}
        className={classNames('bg-white cursor-pointer mb-4', {
          'blog-results__item': size.isMdOrLower,
        })}
      >
        <div className='row'>
          <div className='col-xxl-4 col-xl-5 col-6'>
            <div className='blog-results__img-container blog-results__img-container--rounded bg-white'>
              <PrismicImage image={data.main_image} />
            </div>
          </div>
          <div className='col-xxl-8 d-flex d-lg-block flex-fill flex-column justify-content-center col-xl-7 col-6'>
            <p className={'fs-fluid-11-24 text-muted mb-0'}>
              {data.modified_date}
            </p>
            <p className={'fs-fluid-11-24 text-semibold mb-2'}>{data.title}</p>
          </div>
        </div>
      </div>
    </Link>
  )
}

export default BlogPostMoreResult
